/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { FC, MouseEventHandler } from 'react';
import { Stack, Card as MatCard, SxProps, Theme, Grid } from '@mui/material';
import { UserActions } from '@/components/blocks/Card/UserActions';
import { CardMain } from '@/components/blocks/Card/Main';
import { cardSX } from '@/components/blocks/Card/styles/card';
import { combineSX } from '@/utils/combineSX';

type Props = {
	cardHeader?: JSX.Element;
	cardMain?: JSX.Element;
	cardFooter?: JSX.Element;
	testId: string;
	actions?: any[];
	confirmLabel?: string;
	cancelLabel?: string;
	onCardArea?: MouseEventHandler<HTMLButtonElement>;
	extraSX?: SxProps<Theme>[];
	personData?: boolean;
	editPerson?: any;
	isCheckout?: boolean;
	indexMissing?: number;
};

const EMPTY_SX: SxProps<Theme>[] = [];
export const Card: FC<Props> = ({
	cardMain,
	actions,
	cardFooter,
	confirmLabel,
	cancelLabel,
	testId,
	onCardArea,
	extraSX = EMPTY_SX,
	personData,
	isCheckout,
	indexMissing,
}) => (
	<MatCard sx={combineSX([cardSX, ...extraSX])}>
		<Stack
			justifyContent="space-between"
			alignItems="stretch"
			sx={{ height: isCheckout ? '100%' : '155px' }}
		>
			<Grid padding={!personData ? '20px 20px 0 20px' : '20px'}>
				<CardMain
					onCardArea={onCardArea}
					content={cardMain as JSX.Element}
					divider={!!actions?.length}
					testId={testId}
					personData={personData}
				/>
			</Grid>
			{actions?.length && !personData ? (
				<UserActions {...{ testId, actions, confirmLabel, cancelLabel, indexMissing }} />
			) : null}
			{cardFooter}
		</Stack>
	</MatCard>
);
